import React from 'react';
import PropTypes from 'prop-types';

import {
  HOUSEHOLD_LISTING_STATUS_ARCHIVED,
  HOUSEHOLD_APPLICATION_STATUS_PAID,
  HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED,
  HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED_BY_PARTNER,
} from 'common/householdConstants';
import { isAllRoommatesApplicationsAtSameStatus } from 'common/householdHelpers';
import { getMarketSecurityDepositLabel } from 'common/listingHelpers';
import { formatPhoneNumber } from 'common/formatters';

const SrRenterApplicationStatusMessage = ({
  householdListing,
  roommateApplications,
  customerSupportPhone,
  market,
}) => {
  let applicationStatusMessage = (
    <span className="message">
      {`The landlord won’t process your application until every roommate has completed
             and paid their application.`}
    </span>
  );

  if (
    householdListing.status === HOUSEHOLD_LISTING_STATUS_ARCHIVED &&
    householdListing.cancelReason !== HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED &&
    householdListing.cancelReason !== HOUSEHOLD_APPLICATION_ARCHIVE_REASON_REJECTED_BY_PARTNER
  ) {
    applicationStatusMessage = (
      <span className="message">
        {`The Sunroom Team has marked your application for this home as 'closed.'
          If you want to apply again, visit the listing page above and click 'apply now.'`}
      </span>
    );
  } else if (householdListing.status === HOUSEHOLD_LISTING_STATUS_ARCHIVED) {
    applicationStatusMessage = (
      <span className="message">
        {`Unfortunately, your application wasn't accepted for this home. On the bright side,
           your application is complete and can be used for any property in Texas!
           Please contact Sunroom Support at   `}
        <a
          href={`sms:+1${customerSupportPhone}`}
          className="blue-bright weight-medium inline font-normal"
        >
          {`${formatPhoneNumber(customerSupportPhone)}`}
        </a>
        {' if you have any questions.'}
      </span>
    );
  } else if (
    isAllRoommatesApplicationsAtSameStatus({
      status: HOUSEHOLD_APPLICATION_STATUS_PAID,
      applications: roommateApplications,
    })
  ) {
    applicationStatusMessage = (
      <span className="message">
        {`Thanks for completing your application! Our team is reviewing
               your documents now and preparing to send it to the landlord.`}
      </span>
    );
  } else if (
    isAllRoommatesApplicationsAtSameStatus({
      status: HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
      applications: roommateApplications,
    })
  ) {
    applicationStatusMessage = (
      <span className="message">
        {`Your application has been sent to the landlord. We'll follow
              up with the landlord and their real estate agent daily, but
              applications usually take 3-7 business days to be processed. Hang tight!`}
      </span>
    );
  } else if (
    isAllRoommatesApplicationsAtSameStatus({
      status: HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
      applications: roommateApplications,
    })
  ) {
    applicationStatusMessage = (
      <span className="message">
        {`Congratulations, your application has been accepted! If you
               haven't paid the ${getMarketSecurityDepositLabel(market)} or signed the lease, please
               do so within the next 48 hours. Please contact Sunroom support
               at `}
        <a
          href={`sms:+1${customerSupportPhone}`}
          className="blue-bright weight-medium inline font-normal"
        >
          {`${formatPhoneNumber(customerSupportPhone)}`}
        </a>
        {' if you need assistance.'}
      </span>
    );
  }

  return applicationStatusMessage;
};

SrRenterApplicationStatusMessage.propTypes = {
  householdListing: PropTypes.object.isRequired,
  roommateApplications: PropTypes.array.isRequired,
  customerSupportPhone: PropTypes.string.isRequired,
  market: PropTypes.object,
};

SrRenterApplicationStatusMessage.displayName = 'SrRenterApplicationStatusMessage';

export default SrRenterApplicationStatusMessage;
